const contact = {
  mail: {
    content: '',
    icon: 'envelope-fill'
  },
  phone: {
    content: '',
    icon: 'telephone-fill'
  },
  homepage: {
    content: '',
    icon: 'house-door-fill',
    text: 'zum Shop'
  },
  phoneTo: {
    content: null
  },
  name: {
    content: ''
  },
  company: {
    content: ''
  },
  street: {
    content: ''
  },
  number: {
    content: ''
  },
  zip: {
    content: ''
  },
  city: {
    content: ''
  },
  country: {
    content: ''
  },
  fax: {
    content: ''
  }
}

export default {
  contact
}
